import React, { useEffect, useRef } from "react";
import clock from '../assets/images/clock.svg'

import lightGreenArrowOutline from '../assets/images/light-outline-arrow.svg'
import { useNavigate, Link } from "react-router-dom";

import axios from "axios";
import IP from "../variable";

import { useQuery } from "react-query";
import useAxios from "../utils/useAxios";


const AllMeetings = () => {

    const navigate = useNavigate()

    let api = useAxios()

    const { isLoading, isError, error, data, isSuccess, refetch } = useQuery(
        "all-meetings",
        async () => api.get(`${IP}/company/available-companies`),
        { cacheTime: 0 }
    );

    const companiesData = data?.data ?? []


    return (
        <>
            <div className="table-header">
                Available Companies
            </div>

            {
                isLoading ?

                    <div className="placeholder-wave">
                        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>
                        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>
                        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>
                        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>
                        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>

                    </div>
                    :

                    companiesData.length > 0 ?

                    companiesData.map((company) => (
                        
                        <div key={company.id} className="custom-card">
                            <span className="main-text">
                                {company.name}
                            </span>
                            <span>
                                <span className="d-flex align-items-center">
                                    <span className="highlight ms-3">
                                        {company.location}
                                    </span>
                                    <Link
                                        to={`/company/${company?.id}`}
                                        className="view-investors-btn"
                                    >
                                        View Slots
                                    </Link>
                                </span>
                            </span>
                        </div>
                    ))
                    :
                    <div className="text-center">
                        <p>No Records Found</p>
                    </div>

            }
        </>
    )
}


export default AllMeetings;